import {IPrimaryKey} from "../interfaces/iprimary-key";

export class TiposConselhoPrimaryKey implements IPrimaryKey<TiposConselhoModel> {
  tipo_Conselho: number = 0;

  get id(): string {
    return `${this.tipo_Conselho}`;
  }
}

export class TiposConselhoModel extends TiposConselhoPrimaryKey {
  descricao: string = '';
}
